<template>
    <div>
        <y-panel-grid :service="$services.Amin.membersGrid" />
    </div>
</template>

<script>

    // Mixins
    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'CommentingPostList',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        breadcrumbs() {
            return [
                this.$bc('dashboard', this.$t('breadcrumbs.dashboard')),
                this.$bc(this.$t('breadcrumbs.commenting')),
            ];
        },
    };
</script>
